module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/main-view_614e6af4c78fb63fdfb25e86c742738e.png";